import { ModelOptions } from '../.../../../types';
import Api, { handleError } from '../Api';
import request from '../request';

import { url } from './config';
import { Tour, TourClassPrice } from './types';

class ExtendedApi extends Api<Tour> {
    async post(body: Partial<Tour>) {
        try {
            const res = await request.post(`${url}`, body);
            return res.data;
        } catch (error) {
            return handleError(error);
        }
    }
    async duplicateManyByFromDate(id: string, body: Date[]) {
        try {
            const res = await request.post(`${url}-duplicate-many-by-from-date/${id}`, body);
            return res.data;
        } catch (error) {
            return handleError(error);
        }
    }
    async query(
        query: any,
        options?: { limit?: number | string; offset?: number | string; sort?: any }
    ): Promise<{ rows: Tour[]; total: number }> {
        const params: Record<string, any> = { query: JSON.stringify(query) };
        if (options?.limit !== undefined) params.limit = options.limit;
        if (options?.offset !== undefined) params.offset = options.offset;
        if (options?.sort) params.sort = JSON.stringify(options.sort);
        try {
            const res = await request.get(`${url}-query`, { params });
            return res.data;
        } catch (error) {
            return handleError(error);
        }
    }
    // getTravelFilesByTourDetails(query: any) {
    //     return request.get(`${url}-search-by`, { params: query }).then(handleData).catch(handleError);
    // }
    async getPartialFormat(params: Partial<Tour> = {}, options?: ModelOptions) {
        try {
            const res = await request.get(`${url}/list/partial-format`, {
                params: { ...params, ...options },
                timeout: 15 * 1000
            });
            return res.data;
        } catch (error) {
            throw handleError(error);
        }
    }
    async queryPartialFormat(query: any, options?: { limit?: number | string }) {
        try {
            const params: Record<string, any> = { query: JSON.stringify(query) };
            if (options?.limit !== undefined) params.limit = options.limit;
            const res = await request.get(`${url}/list/partial-format`, { params });
            return res.data;
        } catch (error) {
            throw handleError(error);
        }
    }
    async getSellingPriceByTourId(params: { tourId: string; classId: string }) {
        try {
            const res = await request.get(`${url}-selling-by-tour-id`, {
                params
            });
            return res.data;
        } catch (error) {
            throw handleError(error);
        }
    }
    /** Base price per priced class, for the Travel File list's group price popup. */
    async getClassPrices(tourId: string | number): Promise<TourClassPrice[]> {
        try {
            const res = await request.get(`${url}-class-prices/${tourId}`);
            return Array.isArray(res.data) ? res.data : [];
        } catch (error) {
            throw handleError(error);
        }
    }
}

const toursApi = new ExtendedApi(url);

export default toursApi;
